<app-hint [introObj]="introObj" (close)="close()"></app-hint>
